import React from 'react';

import { useMediaQuery } from 'react-responsive';

import { Country } from 'app/types';

import { detailUrl } from 'common/utils/conversions';

import style from './DestinationCard.module.scss';

interface CompProps {
  destination: Country;
}

const DestinationCard = ({ destination }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div
      className={`${isMobile ? 'col-9' : `${style.imgContainer}`} ${style.container}`}
      key={destination.id}
    >
      <a href={detailUrl('countries', destination.id, destination.name)}>
        {destination.photos && (
          <img
            src={`${destination.photos[0]}`}
            className={`${style.destinationImageContainer}`}
            alt={`Photo of ${destination.name}`}
          />
        )}
      </a>
      <div className={style.bottomLeft}>{destination.name}</div>
    </div>
  );
};

export default DestinationCard;
